import type { FaireProductEntity } from "../../entity_types/product";

export const p_7mynzxb7bf: FaireProductEntity = {
  token: "p_7mynzxb7bf",
  type: "product",
  name: "Colombo Pasta Bowl / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/8c95dd239aebb096de475fadef3ba022c4c90c46e1b0c2b0fe8f1ee11455ad7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b73e0cd37a25445818a5e77bcb32d4639c189167cec3225f5b54f6d166e54829.jpeg",
    "https://cdn.faire.com/fastly/edb7523487f33a8a2e2233565c77556dee52ab17aec317a075f04ba98521b52e.jpeg",
    "https://cdn.faire.com/fastly/4c930b3ea3f8b74b53e150b46c1ffb7460b1c11e2170240ba1ca2ef9bc36f5eb.jpeg",
    "https://cdn.faire.com/fastly/8f98657bd7880c257c1f3f8877b7e3e8fc641a67ad85479d7f7bb25ee1a2a980.jpeg",
    "https://cdn.faire.com/fastly/3c85bc784b19fc0d653673f6f25fd4393e5fcd5de5995eea7af7656ed4ca727c.jpeg",
    "https://cdn.faire.com/fastly/3b6b78f3a639fa0ff0860dd09ae5c148188e29d49f5425f2cb4aab2b4360eac5.jpeg",
    "https://cdn.faire.com/fastly/1cc4168aa2d8b97a5a93dc935c7abc46cf2e884d58e42ad83ff0939415b8c2b7.jpeg",
    "https://cdn.faire.com/fastly/b470e19a760efd15d75d320c5946f92e7382a1fb15b6bb8ab093ca0bff2ce447.jpeg",
    "https://cdn.faire.com/fastly/7242ad6281856f9926024b588febec7d17b6c3f7f5f7cea99860f41a969a249f.jpeg",
    "https://cdn.faire.com/fastly/534ba9f52bb7bfe3d0e0aea32e2d86424ef3ccd1d997d582f60b9ab3b7199cf9.jpeg",
  ],
  priceDollars: 35,
  description:
    'Colombo is a pleasing dinnerware range inspired by our love of sharing food with friends and family and creating memories around the table.\n\nThe well-considered collection of plates and bowls is perfect for hosting a dinner party for larger group and for making everyday meals for your loved ones special.\n\nColombo range allows you to be creative in how you set your table to best accompany your dishes, mood and needs.\n\nYou can match the colours across the range or mix them, to create your own unique set and add a curated eclectic feel to your table.\n\nBeautifully handcrafted from coloured porcelain – a superior strong and hardwearing ceramic, that if cared for, should last a lifetime. Dishwasher and microwave-safe.\n\nColombo pasta bowl is great for everyday meals and for serving sharing dishes.\n\nMaterial: Porcelain\nSize: 22 x 5cm / 8.7 x 1.9"\nSet of 2',
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:33.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
